// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img[data-v-03acd5f7]{cursor:pointer;padding:5px;border:3px solid transparent}img[data-v-03acd5f7]:not(:last-of-type){margin-right:10px}.active[data-v-03acd5f7]{border:3px solid #000}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
